import { render } from "./QwForm.vue?vue&type=template&id=118c043c"
import script from "./QwForm.vue?vue&type=script&lang=js"
export * from "./QwForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__